import React, { useState, useContext } from "react";
import { Button, Box, Grid, Stack, TextField, Typography } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { AccountContext } from "./Account";
import { SnackbarOrigin, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export const ChangePassword = () => {

    const { getSession, authenticate, logout } = useContext(AccountContext)
    const [stateMsg, setStateMsg] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = stateMsg;
    const [msg, setMsg] = useState("")
    const [severity, setSeverity] = useState("")
    const [password, setPassword] = useState("")
    const [newPassword, setNewPassword] = useState("");
    let navigate = useNavigate();
    const messageBox = (severity, msg) => {
        setSeverity(severity)
        setMsg(msg)
        var newState = {
            vertical: 'top',
            horizontal: 'center',
        }
        setStateMsg({ open: true, ...newState });
    }
    const handleClose = () => {
        setStateMsg({ ...stateMsg, open: false });
    };
    const onSubmit = async () => {
        if (password.trim().length === 0 || newPassword.trim().length === 0) {
            return;
        }
        if (password === newPassword) {
            messageBox("error", "Old and new passwords cannot be the same.");
            return;
        }
        await getSession().then(({ user, email }) => {
            authenticate(email, password)

                .then(() => {
                    user.changePassword(password, newPassword, (err, result) => {


                        if (err) {
                            messageBox("error", err.message)
                        }

                        else {

                            messageBox("success", 'Password Changed Successfully!')

                        }

                    });
                })
                .catch((err) => {
                    // console.log(err)

                    messageBox("error", "Incorrect old password please enter correct password");
                });

        });
    };

    return (
        <div>
            <Grid flex={3} p={1} sx={{ boxShadow: 0, marginRight: 1, maxHeight: 1 }}>
                <Stack direction={"column"} p={1} gap={1}>
                    <Grid container sx={{ flexDirection: 'column', width: '40%' }} spacing={1}>
                        <Grid item>
                            <Box sx={{ flexDirection: 'column' }}>
                                <Typography fontSize={15}>
                                    Old Password
                                </Typography>
                                <TextField size="small" type={'password'} value={password} onChange={(e) => { setPassword(e.target.value) }} sx={{ width: '100%', color: '#e0e0e0', borderColor: 'gray.500' }} inputProps={{ style: { height: "15px" } }}>
                                </TextField>
                                <label for="validationError" class="form-label text-danger">{password.trim().length == 0 ? "old password is required" : ""}</label>
                            </Box>
                        </Grid>
                        <Grid item>
                            <Box sx={{ flexDirection: 'column' }}>
                                <Typography fontSize={15}>
                                    New Password
                                </Typography>
                                <TextField size="small" type={'password'} value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} sx={{ width: '100%' }} inputProps={{ style: { height: "15px" } }}>
                                </TextField>
                                <label for="validationError" class="form-label text-danger">{newPassword.trim().length == 0 ? "new password is required" : ""}</label>
                            </Box>
                        </Grid>
                        <Grid item>
                            <Box display={'flex'} sx={{ justifyContent: 'flex-start' }}>
                                <Box display={'flex'} sx={{ width: 330, justifyContent: 'space-between' }}>
                                    <Button size="small" variant="contained" color="success" onClick={onSubmit} sx={{ width: 135 }}>Change Password</Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                key={vertical + horizontal}
            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {msg}
                </Alert>
            </Snackbar>
        </div>

    );

};
